<template>
    <modal :open="open" @close="$emit('close')" title="You have unsaved changes">

        <h3 v-t="'Are you sure you want to leave this page?'"></h3>

        <div class="modal__done">
            <a class="button" @click="$emit('close')"><span v-t="'No, stay here'"></span></a>
            <a class="button--close" @click="$emit('leave')"><span v-t="'Yes, leave'"></span></a>
        </div>

    </modal>
</template>

<script>
    import Modal from '@/components/Modal.vue'

    export default {
        props: ['open'],
        components: {
            Modal
        },
        data () {
            return {
            }
        },
        methods: {
        }
    }
</script>
